var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"callContainer"},[_c('div',[_c('span',[_vm._v("Cadastre-se para receber "),_c('strong',[_vm._v("nossas ofertas exclusivas!")])])]),_c('div',{staticClass:"inputContainer"},[_c('input',{attrs:{"type":"text","placeholder":"Digite seu e-mail"}}),_c('input',{attrs:{"type":"text","placeholder":"Digite seu nome"}}),_c('button',[_vm._v("Cadastrar")])])])
}]

export { render, staticRenderFns }